/**
 * Never let the map collapse below this, so a very short window scrolls rather than
 * shrinking the map to a sliver the floating card cannot fit in.
 */
export const MIN_MAP_HEIGHT_PX = 320;

/**
 * How tall the recording map must be to fill the window below wherever it starts.
 *
 * The map used to be a fixed 84svh, which only fits when the header and breadcrumb bar
 * above it come to exactly 16% of the window. On a shorter window they are a larger
 * share, so the map ran past the bottom edge and cut off the floating recording card
 * and its elevation chart. Measuring the map's own top avoids hard-coding a header
 * height that changes with the breakpoint.
 *
 * `mapTop` is the map's distance from the top of the document, not the viewport, so
 * the answer doesn't change when the page has been scrolled.
 */
export function mapHeightBelow(viewportHeight: number, mapTop: number): number {
  return Math.max(MIN_MAP_HEIGHT_PX, Math.round(viewportHeight - mapTop));
}
